// import React, { useState, useMemo } from "react";
// import {
//   ComposableMap,
//   Geographies,
//   Geography,
//   Marker,
//   ZoomableGroup
// } from "react-simple-maps";
// // import { csv } from "d3-fetch";
// import { scaleLinear } from "d3-scale";
// // import sortBy from "lodash/sortBy";
// import PlaceIcon from '@mui/icons-material/Place';
// import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

// const geoUrl =
//   "https://unpkg.com/world-atlas@2.0.2/countries-110m.json";

// const MapChart = () => {

//   const data = [
//     {
//       "country": "China",
//       "city": "Chongqing",
//       "lat": "29.5628",
//       "lng": "106.5528",
//       "population": "16",
//       "date": '16-04-2023'
//     },
//     {
//       "country": "Turkey",
//       "city": "Istanbul",
//       "lat": "41.0138",
//       "lng": "28.9497",
//       "population": "15",
//       "date": '17-04-2023'
//     },
//     {
//       "country": "Argentina",
//       "city": "Buenos Aires",
//       "lat": "-34.6051",
//       "lng": "-58.4004",
//       "population": "15",
//       "date": '18-04-2023'
//     },
//     {
//       "country": "India",
//       "city": "Kolkata (Calcutta)",
//       "lat": "22.5335",
//       "lng": "88.3560",
//       "population": "15",
//       "date": '19-04-2023'
//     }
//   ];
//   const maxValue = Math.max(...data.map(d => +d.population));

//   const [selectedLoc, setSelectedLoc] = useState(data[0].city)
//   const [selectedLocDate, setSelectedLocDate] = useState(data[0].date)

//   const setDetails = (loc, date) => {
//     setSelectedLoc(loc);
//     setSelectedLocDate(date)
//   }

//   // useEffect(() => {
//   //   setSelectedLoc(data[0].city);
//   //   setSelectedLocDate(data[0].date)
//   // }, [data]);

//   const popScale = useMemo(
//     () => scaleLinear().domain([0, maxValue]).range([0, 24]),
//     [maxValue]
//   );

//   return (
//     <>
   

//       <ComposableMap
//         projection="geoMercator"
//         projectionConfig={{
//           scale: 145,
//           rotation: [-11, 0, 0],
//         }}
//         width={900}
//         height={900}
//         style={{ width: "100%", height: "100%" }}
//       >
//         <ZoomableGroup zoom={1} translateExtent={[[0, 0], [1000, 900]]}>
//         <Geographies geography={geoUrl}>
//           {({ geographies }) =>
//             geographies.map((geo) => (
//               <Geography
//                 key={geo.rsmKey}
//                 geography={geo}
//                 fill="#EAEAEC"
//                 stroke="#D6D6DA"
//               />
//             ))
//           }
//         </Geographies>
//           {data.map(({ city, lng, lat, population, date }) => {
//             return (
//                 <Marker key={city} coordinates={[+lng, +lat]} onClick={() => setDetails(city, date)}>
//                      <circle fill={selectedLoc !== city ? "orange" : "red"} stroke="#FFF" r={popScale(population)} />
//                 </Marker>
//             );
//           })}
//         </ZoomableGroup>
//       </ComposableMap>
//        <p><PlaceIcon></PlaceIcon> {selectedLoc}</p>
//       <p><CalendarMonthIcon></CalendarMonthIcon> {selectedLocDate}</p> 
//     </>
//   );
// };

// export default MapChart;

// import React, { useState, useMemo } from "react";
// import {
//   ComposableMap,
//   Geographies,
//   Geography,
//   Marker,
//   ZoomableGroup
// } from "react-simple-maps";
// import { scaleLinear } from "d3-scale";
// import PlaceIcon from '@mui/icons-material/Place';
// import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
// import { geoCentroid } from "d3-geo";


// const geoUrl = "https://unpkg.com/world-atlas@2.0.2/countries-110m.json";

// const MapChart = ({ data }) => {
//   const [selectedLoc, setSelectedLoc] = useState("");
//   const [selectedLocDate, setSelectedLocDate] = useState("");

//   const setDetails = (loc, date) => {
//     setSelectedLoc(loc);
//     setSelectedLocDate(date);
//   };

//   const maxValue = useMemo(() => {
//     return Math.max(...(data?.map(d => +d.population) || [0]));
//   }, [data]);

//   const popScale = useMemo(
//     () => scaleLinear().domain([0, maxValue]).range([0, 24]),
//     [maxValue]
//   );

//   const highlightedCountries = useMemo(() => {
//     return new Set(data?.map(d => d.country));
//   }, [data]);
  

//   return (
//     <>
//       <ComposableMap
//         projection="geoMercator"
//         projectionConfig={{
//           scale: 145,
//           rotation: [-11, 0, 0],
//         }}
//         width={900}
//         height={900}
//         style={{ width: "100%", height: "100%" }}
//       >
//         <ZoomableGroup zoom={1} translateExtent={[[0, 0], [1000, 900]]}>
//         <Geographies geography={geoUrl}>
//   {({ geographies }) =>
//     geographies.map((geo) => {
//       const countryName = geo.properties.NAME;
//       const isHighlighted = highlightedCountries.has(countryName);

//       return (
//         <Geography
//           key={geo.rsmKey}
//           geography={geo}
//           fill={isHighlighted ? "#FFA500" : "#EAEAEC"} // Highlighted country
//           stroke="#D6D6DA"
//         />
//       );
//     })
//   }
// </Geographies>

//           {data?.map(({ city, country, lng, lat, population, date }, index) => (
//             <Marker
//             key={index}
//             coordinates={[+lng, +lat]}
//             onClick={() => setDetails(country, date)}
//           >
//             <circle
//               fill={selectedLoc !== city ? "orange" : "red"}
//               stroke="#FFF"
//               r={popScale(population || 10)}
//             />
//             <title>{`${city}, ${country} - Pop: ${population}`}</title>
//             </Marker>
//           ))}
//         </ZoomableGroup>
//       </ComposableMap>

//       {selectedLoc && (
//         <>
//           <p><PlaceIcon /> {selectedLoc}</p>
//           <p><CalendarMonthIcon /> {selectedLocDate}</p>
//         </>
//       )}
//     </>
//   );
// };

// export default MapChart;


// import React, { useState, useMemo, useEffect } from "react";
// import {
//   ComposableMap,
//   Geographies,
//   Geography,
//   Marker,
//   ZoomableGroup
// } from "react-simple-maps";
// import { scaleLinear } from "d3-scale";
// import PlaceIcon from "@mui/icons-material/Place";
// import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// import { geoCentroid } from "d3-geo";

// const geoUrl = "https://unpkg.com/world-atlas@2.0.2/countries-110m.json";

// const MapChart = ({ data }) => {
//   const [selectedLoc, setSelectedLoc] = useState("");
//   const [selectedLocDate, setSelectedLocDate] = useState("");

//   useEffect(() => {
//     console.log("Your data countries:", data.map(d => d.country));
//   }, [data]);
  
//   useEffect(() => {
//     fetch(geoUrl)
//       .then(res => res.json())
//       .then(world => {
//         const countries = world.objects.countries;
//         console.log("Geo country names example:", countries);
//       });
//   }, []);
  

//   const setDetails = (loc, date) => {
//     setSelectedLoc(loc);
//     setSelectedLocDate(date);
//   };

//   const maxValue = useMemo(() => {
//     return Math.max(...(data?.map((d) => +d.population) || [0]));
//   }, [data]);

//   const popScale = useMemo(
//     () => scaleLinear().domain([0, maxValue]).range([0, 24]),
//     [maxValue]
//   );


// const highlightedCountries = useMemo(() => {
//   const countryNameMap = {
//     usa: "united states of america",
//     uk: "united kingdom",
//     uae: "united arab emirates",
//     india: "india",
//     germany: "germany",
//     // Add more as needed
//   };

//   return new Set(
//     data
//       ?.map((d) =>
//         countryNameMap[d.country?.toLowerCase().trim()] || d.country?.toLowerCase().trim()
//       )
//       .filter(Boolean)
//   );
// }, [data]);


//   return (
//     <>
//       <ComposableMap
//         projection="geoMercator"
//         projectionConfig={{
//           scale: 145,
//           rotation: [-11, 0, 0],
//         }}
//         width={900}
//         height={900}
//         style={{ width: "100%", height: "100%" }}
//       >
//         <ZoomableGroup zoom={1} translateExtent={[[0, 0], [1000, 900]]}>
//           {/* 🌍 Highlight Countries */}
//           <Geographies geography={geoUrl}>
//             {({ geographies }) =>
//               geographies.map((geo) => {
//                 const countryName = geo.properties.NAME?.toLowerCase().trim();
// const isHighlighted = highlightedCountries.has(countryName);

//                 return (
//                   <Geography
//                     key={geo.rsmKey}
//                     geography={geo}
//                     fill={isHighlighted ? "#FFA500" : "#EAEAEC"}
//                     stroke="#D6D6DA"
//                   />
//                 );
//               })
//             }
//           </Geographies>

//           {/* 🔴 Add red circle to the centroid of highlighted countries */}
//           <Geographies geography={geoUrl}>
//             {({ geographies }) =>
//               geographies.map((geo) => {
//                 const countryName = geo.properties.NAME?.toLowerCase().trim();
//                 if (highlightedCountries.has(countryName)) {
//                   const [longitude, latitude] = geoCentroid(geo);
//                   return (
//                     <Marker
//                       key={`${countryName}-marker`}
//                       coordinates={[longitude, latitude]}
//                     >
//                       <circle r={8} fill="red" stroke="#fff" strokeWidth={1} />
//                       <title>{geo.properties.NAME}</title>
//                     </Marker>
//                   );
//                 }
//                 return null;
//               })
//             }
//           </Geographies>

//           {/* 📍 User-provided lat/lng markers */}
//           {data?.map(({ city, country, lng, lat, population, date }, index) => (
//             <Marker
//               key={index}
//               coordinates={[+lng, +lat]}
//               onClick={() => setDetails(country, date)}
//             >
//               <circle
//                 fill={selectedLoc !== country ? "orange" : "red"}
//                 stroke="#FFF"
//                 r={popScale(population || 10)}
//               />
//               <title>{`${city}, ${country} - Pop: ${population}`}</title>
//             </Marker>
//           ))}
//         </ZoomableGroup>
//       </ComposableMap>

//       {/* 📝 Selected Info */}
//       {selectedLoc && (
//         <div style={{ marginTop: "10px" }}>
//           <p>
//             <PlaceIcon /> {selectedLoc}
//           </p>
//           <p>
//             <CalendarMonthIcon /> {selectedLocDate}
//           </p>
//         </div>
//       )}
//     </>
//   );
// };

// export default MapChart;


import React, { useState, useMemo } from "react";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
  ZoomableGroup
} from "react-simple-maps";
// import { csv } from "d3-fetch";
import { scaleLinear } from "d3-scale";
// import sortBy from "lodash/sortBy";
import PlaceIcon from '@mui/icons-material/Place';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const geoUrl =
  "https://unpkg.com/world-atlas@2.0.2/countries-110m.json";

const MapChart = () => {

  const data = [
    {
      "country": "Japan",
      "city": "Tokyo",
      "lat": "35.6895",
      "lng": "139.6917",
      "population": "37",
      "date": '20-04-2023'
    },
    {
      "country": "India",
      "city": "Delhi",
      "lat": "28.6667",
      "lng": "77.2167",
      "population": "30",
      "date": '21-04-2023'
    },
    {
      "country": "China",
      "city": "Shanghai",
      "lat": "31.2222",
      "lng": "121.4581",
      "population": "27",
      "date": '20-04-2023'
    },
    {
      "country": "Brazil",
      "city": "São Paulo",
      "lat": "-23.5475",
      "lng": "-46.6361",
      "population": "22",
      "date": '22-04-2023'
    },
    {
      "country": "Mexico",
      "city": "Ciudad de México (Mexico City)",
      "lat": "19.4273",
      "lng": "-99.1419",
      "population": "22",
      "date": '21-04-2023'
    },
    {
      "country": "Bangladesh",
      "city": "Dhaka",
      "lat": "23.7104",
      "lng": "90.4074",
      "population": "21",
      "date": '14-04-2023'
    },
    {
      "country": "Egypt",
      "city": "Al-Qahirah (Cairo)",
      "lat": "30.0392",
      "lng": "31.2394",
      "population": "21",
      "date": '19-04-2023'
    },
    {
      "country": "China",
      "city": "Beijing",
      "lat": "39.9075",
      "lng": "116.3972",
      "population": "20",
      "date": '18-04-2023'
    },
    {
      "country": "India",
      "city": "Mumbai (Bombay)",
      "lat": "19.0740",
      "lng": "72.8808",
      "population": "20",
      "date": '17-04-2023'
    },
    {
      "country": "Japan",
      "city": "Kinki M.M.A. (Osaka)",
      "lat": "34.6758",
      "lng": "135.5538",
      "population": "19",
      "date": '16-04-2023'
    },
    {
      "country": "United States of America",
      "city": "New York-Newark",
      "lat": "40.7170",
      "lng": "-74.0037",
      "population": "19",
      "date": '21-04-2023'
    },
    {
      "country": "Pakistan",
      "city": "Karachi",
      "lat": "24.9056",
      "lng": "67.0822",
      "population": "16",
      "date": '20-04-2023'
    },
    {
      "country": "China",
      "city": "Chongqing",
      "lat": "29.5628",
      "lng": "106.5528",
      "population": "16",
      "date": '16-04-2023'
    },
    {
      "country": "Turkey",
      "city": "Istanbul",
      "lat": "41.0138",
      "lng": "28.9497",
      "population": "15",
      "date": '17-04-2023'
    },
    {
      "country": "Argentina",
      "city": "Buenos Aires",
      "lat": "-34.6051",
      "lng": "-58.4004",
      "population": "15",
      "date": '18-04-2023'
    },
    {
      "country": "India",
      "city": "Kolkata (Calcutta)",
      "lat": "22.5335",
      "lng": "88.3560",
      "population": "15",
      "date": '19-04-2023'
    }
  ];
  const maxValue = 0;

  const [selectedLoc, setSelectedLoc] = useState(data[0].city)
  const [selectedLocDate, setSelectedLocDate] = useState(data[0].date)

  const setDetails = (loc, date) => {
    setSelectedLoc(loc);
    setSelectedLocDate(date)
  }

  // useEffect(() => {
  //   setSelectedLoc(data[0].city);
  //   setSelectedLocDate(data[0].date)
  // }, [data]);

  const popScale = useMemo(
    () => scaleLinear().domain([0, maxValue]).range([0, 24]),
    [maxValue]
  );

  return (
    <>
      <ComposableMap
        projection="geoMercator"
        projectionConfig={{
          scale: 145,
          rotation: [-11, 0, 0],
        }}
        width={900}
        height={600}
        style={{ width: "100%", height: "100%" }}
      >
        <ZoomableGroup zoom={1} translateExtent={[[0, 0], [1000, 900]]}>
          <Geographies geography={geoUrl}>
            {({ geographies }) =>
              geographies.map((geo) => (
                <Geography key={geo.rsmKey} geography={geo} fill="#EAEAEC" />
              ))
            }
          </Geographies>
          {data.map(({ city, lng, lat, population, date }) => {
            return (
              <Marker key={city} coordinates={[lng, lat]} onClick={() => setDetails(city, date)}>
                <circle fill={selectedLoc !== city ? "orange" : "red"} stroke="#FFF" r={popScale(population)} />
              </Marker>
            );
          })}
        </ZoomableGroup>
      </ComposableMap>
      {/* <p><PlaceIcon></PlaceIcon> {selectedLoc}</p>
      <p><CalendarMonthIcon></CalendarMonthIcon> {selectedLocDate}</p> */}
    </>
  );
};

export default MapChart;
